import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
export function ProductInUseSection() {
  return <section className="py-20 bg-white border-b border-gray-100" data-id="element-327">
      <Container data-id="element-328">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-329">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-2 md:order-1 space-y-6" data-id="element-330">
            <h3 className="text-2xl font-serif text-gray-900 mb-6" data-id="element-331">
              But the real difference is not just sleep.
            </h3>
            <p className="text-lg text-gray-600 mb-8" data-id="element-332">
              It is what happens because of better sleep.
            </p>

            <div className="space-y-4 text-lg text-gray-800 font-light pl-4 border-l-2 border-blue-200" data-id="element-333">
              <p data-id="element-334">Falling asleep together again.</p>
              <p data-id="element-335">Not waking up irritated.</p>
              <p data-id="element-336">Not apologizing every morning.</p>
              <p data-id="element-337">Not dreading overnight trips.</p>
              <p data-id="element-338">Not worrying about disturbing everyone around you.</p>
              <p className="font-medium text-[#1E40AF] pt-2" data-id="element-339">
                Not hearing: “You kept me awake all night.” again.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-1 md:order-2" data-id="element-340">
            <img src="https://cdn.magicpatterns.com/uploads/6eckVP7hNnvvJ78MfG1Kd4/ChatGPT_Image_May_9,_2026,_11_51_32_PM.png" alt="Happy customer holding SnoreStop" className="w-full max-w-md mx-auto rounded-2xl shadow-xl" data-id="element-341" />
          </motion.div>
        </div>
      </Container>
    </section>;
}